import { Component, OnInit, Input, TemplateRef, ViewChild, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SweetAlertResult } from 'sweetalert2';

import { SharedService } from '@services/shared.service';
import { ApiTransactionService } from '@services/api-transaction.service';
import { ApiAccountService } from '@services/api-account.service';

import { CustomerModel } from '@models/CustomerModel';
import { CustomerCardModel } from '@models/CardModel';
import { BuyerType, NewTransactionTicketModel, ProductOrderModel, TicketOrderModel } from '@models/TransactionModel';
import { Country, CurrencyType, EventType, PayType, ProductTaxType } from '@models/Enums';

import { ModalFormPurchaseBase } from '@shared/modal-base.component';
import { CardFormComponent } from '@components/card-form/card-form.component';
import { CardPaymentModel } from '@models/RegisterModel';

import { TicketModel } from '@models/TicketModel';
import { EventModel } from '@models/EventModel';


@Component({
    selector: 'app-purchase-ticket-modal',
    templateUrl: './purchase-ticket-modal.component.html',
    styleUrls: ['./purchase-ticket-modal.component.scss']
})
export class PurchaseTicketModalComponent extends ModalFormPurchaseBase<NewTransactionTicketModel> implements OnInit {

    @Input() user: CustomerModel;

    @Input() tickets: TicketModel[] = [];
    @Input() event: EventModel;
    @Input() darkMode = true;
    @Input() country: Country = Country.CR;
    @Input() uniqueLinkCode: string = null; // unique link


    @ViewChild('purchaseModal', { static: true }) modal: TemplateRef<any>;
    @ViewChild('freePurchaseModal', { static: true }) freeModal: TemplateRef<any>;


    model: NewTransactionTicketModel;
    //accordion flags
    paymentMethodAccordion = false;
    pointsAccordion = false;

    assignedSuccess = false;

    constructor(
        private router: Router,
        public sharedService: SharedService,
        public modalService: NgbModal,
        private apiAccountService: ApiAccountService,
        private apiTransactionService: ApiTransactionService) {
        super(modalService);
    }

    ngOnInit(): void {

        this._getPaymentMethods(this.user?.id, false);
    }

    ngOnChanges(changes: SimpleChanges) {

        for (const propName in changes) {
            if (propName === 'tickets') {
                const change = changes[propName];
                if (!change.isFirstChange() && (change.previousValue !== change.currentValue)) {

                    this.onNext();
                }
            }
        }
    }

    onOpen() {

        if (!this.user) {
            return this.sharedService.SwalCustom.fire({
                title: 'Iniciar sesión',
                text: 'Para comprar el Tickets debe iniciar sesión.',
                showCancelButton: true,

                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Iniciar sesión',

                allowOutsideClick: false,

                customClass: {
                    confirmButton: 'btn btn-modal-main',
                    cancelButton: 'btn btn-modal-second'
                },
                buttonsStyling: false
            }).then(
                (result: SweetAlertResult) => {

                    if (result && result.value) {

                        this.router.navigate(['login']);
                    }
                }
            );
        }

        setTimeout(() => window.scrollTo({ top: 0 }), 100);

        this._getPaymentMethods(this.user.id);

        this.onNext();

        let windowsClass = this.darkMode ? 'modal-dialog-end dark-theme' : 'modal-dialog-end'

        if (this.model.subTotal > 0) {

            super.open(this.modal, {
                backdrop: 'static', keyboard: false,
                centered: true, windowClass: 'modal-full'
            });
        } else {

            this.model.total = 0;
            this.model.validationCost = 0;

            super.open(this.freeModal, {
                backdrop: 'static', keyboard: false,
                centered: true, windowClass: 'modal-full'
            });
        }

    }

    onClose() {

        super.close();
    }

    // cuando se selecciona el ticket y va al resumen de pago
    onNext() {

        this.model = new NewTransactionTicketModel({
            vendorId: this.event.vendorId,
            eventId: this.event.id,
            buyerType: BuyerType.Customer,
            customerId: this.user.id,
            currencyType: this.event?.vendor?.currencyType,

            points: 0,
            //pointsValue: variables[1].value,

            products: []
        });

        if(this.uniqueLinkCode != null) this.model.uniqueLinkCode = this.uniqueLinkCode;

        if (this.event.communityId > 0) this.model.communityId = this.event.communityId;

        this.tickets.forEach(ticket => {

            if (ticket.communityId > 0) this.model.communityId = ticket.communityId;

            // se suma la comisión del client por cada ticket 
            if (ticket.customerCommission > 0) {
                this.model.allCustomerCommission += ticket.customerCommission;
            }

            this.model.subTotal += ticket.priceTotal;
            this.model.taxTotal = 0, // No tiene IVA
                this.model.total += ticket.priceTotal;

            this.model.isCommissionToVendor = ticket.isCommissionToVendor;
            // Se suma la comisión por cada ticket
            this.model.commissionCost += ticket.commissionCost * ticket.quantitySelected;

            this.model.products.push(
                new TicketOrderModel({
                    productId: ticket.id,
                    sku: ticket.sku,
                    productName: ticket.name,

                    quantity: ticket.quantitySelected,
                    quantityOfPlaces: ticket.quantityOfPlaces,

                    points: ticket.points,

                    // Precio en SALE o precio normal
                    price: ticket.allowDiscount ? ticket.priceWithDiscount : ticket.price,

                    tax: 0, // No tiene IVA 
                    taxType: ProductTaxType.Exempt,
                    taxPercent: 0,
                    // totalPrice: product.price
                    currencyType: this.event?.vendor?.currencyType,
                    // Precio proveedor
                    vendorPrice: ticket.vendorPrice,
                    vendorPriceWithTax: ticket.vendorPriceWithTax,
                    // Precio a Givi
                    vendorDiscountType: ticket.vendorDiscountType,
                    vendorPriceWithDiscount: ticket.vendorPriceWithDiscount,

                    // Commission
                    customerCommissionPercent: ticket.customerCommissionPercent,
                    vendorCommissionPercent: ticket.vendorCommissionPercent,

                    shippingProviderId: ticket.shippingProviderId,
                })
            );
        });

        // $0.50 - Esta seteado en el ticket
        this.model.validationCost = this.tickets.length ? this.tickets[0]?.validationCost : 0;

        // El comercio es el que paga el fee
        if (this.model.isCommissionToVendor) {
            // Se resta el fee al subtotal de la transacción. 
            // ** El total de la transacción queda igual al total del precio de los tickets
            this.model.subTotal = this.model.subTotal - (this.model.commissionCost + this.model.validationCost);
        }
        // El usuario es el que paga el fee
        else {
            // Se suma el fee al total de la transacción.
            this.model.total = this.model.total + (this.model.commissionCost + this.model.validationCost);
        }

        this.model.total += this.model.allCustomerCommission;

        super.formInit();
    }

    onToggleAccordion(accordionType) {

        if (accordionType == 2) {
            this.paymentMethodAccordion = !this.paymentMethodAccordion;
        } else {
            if (this.pointsAccordion) {
                /*
                this.model.points = 0;
                this.model.total = this.model.subTotal + (this.model.commissionCost + this.model.validationCost);*/
                // Close points options
                this.onReceivePointsSelected(0);
            }
            this.pointsAccordion = !this.pointsAccordion;
        }
    }

    onReceivePointsSelected(receivedPoints: number) {
        //total points
        this.model.points = receivedPoints;
        // discount in colones
        this.model.pointsDiscount = receivedPoints * this.model.pointsValue;
        //total with the discount
        this.model.total = this.model.subTotal - this.model.pointsDiscount + (this.model.commissionCost + this.model.validationCost);
    }


    onShowGetPoints() {
        this.onClose();
        this.sharedService.setShowGetPointsModal(true);
    }

    onCloseSucess() {
        this.assignedSuccess = false;
        this.sharedService.setEventForModal(null);
    }

    onPay() {

        if (this.model) {

            if (this.model.total > 0 && !this.currentMethod) {
                this.sharedService.SwalCustom.fire({
                    title: 'Error',
                    text: 'No tienes un metodo de pago agregado',
                    // showCancelButton: true,

                    confirmButtonText: 'Cerrar',
                    // confirmButtonText: 'Abrir Givi App',

                    allowOutsideClick: false,

                    customClass: {
                        confirmButton: 'btn btn-modal-main',
                        cancelButton: 'btn btn-modal-second'
                    },
                    buttonsStyling: false
                })

                return
            }

            if (this.model.total > 0 && this.currentMethod) this.model.cardToken = this.currentMethod.token;

            if (this.uniqueLinkCode != null) this.model.uniqueLinkCode = this.uniqueLinkCode;

            // Valid use points
            this.model.payType = this.pointsAccordion && this.model.pointsDiscount > 0 ? PayType.CardPoints : PayType.Card;

            this.sharedService.setLoading(true);

            this.apiTransactionService.payOrderTicket(this.model, this.country).then(
                (order: any) => {

                    this.apiTransactionService.loadAccount();

                    this.sharedService.setLoading(false);

                    this.assignedSuccess = true;

                },
                (err: any) => {

                    this.sharedService.setLoading(false);

                    let errMsg = '';

                    if (typeof err.error?.Message == "string" && err.error?.Message.length) {

                        errMsg = err.error?.Message;
                    }
                    else {
                        errMsg = 'No se pudo realizar la compra. Por favor revisá la información y volvé a intentarlo.';
                    }

                    this.sharedService.showErrorAlert(null, errMsg);
                }
            );
        }
    }

    @ViewChild(CardFormComponent) cardFormComponent: CardFormComponent;

    // La tarjeta la arma app-card-form y llega por (cardChange). null = incompleta.
    onCardChange(card: CardPaymentModel) {

        this.newCard = card;
    }

    onSaveCard(modal: any): void {

        if (!this.newCard) return;

        this.newCard.companyId = this.user.id;

        if (this.cardFormComponent?.isAmexCVC) {

            const errMsg = 'No se aceptan tarjetas American Express. Por favor revisá la información y volvé a intentarlo.';
            this.sharedService.showErrorAlert(null, errMsg);
        }
        else {

            this.sharedService.setLoading(true);

            this.apiAccountService.addCard(this.newCard).then(
                (data: any) => {

                    this.sharedService.setLoading(false); // hide loader

                    this._getPaymentMethods(this.user.id);

                    this.sharedService.showSuccessAlert(
                        null, `La tarjeta fue agregada correctamente`
                    ).then(_ => modal.dismiss());
                },
                (err: any) => {
                    this.sharedService.setLoading(false); // hide loader

                    const errMsg = 'No se pudo agregar la tarjeta. Por favor revisá la información y volvé a intentarlo.';
                    this.sharedService.showErrorAlert(null, errMsg);
                }
            );
        }
    }

    get requireVisa(): boolean {
        // Visa es requerida para Panama en el 
        // Evento 3 - Burger Week Fest & Challenge (Exclusivo Visa) Comunidad
        // Evento 4 - Burger Week Fest & Challenge (Exclusivo Visa)
        const requireVisa = (this.event.id == 3 || this.event.id == 4) && this.event.country == Country.PA;
        return requireVisa;
    }

    get invalidCard(): boolean {

        if (this.currentMethod?.brand) {

            if (this.currentMethod.brand.toLocaleLowerCase() == 'amex') {
                if (this.requireVisa) return true;
                return false;
            } else if (this.currentMethod.brand.toLocaleLowerCase() == 'mastercard') {
                if (this.requireVisa) return true;
                return false;
            } else if (this.currentMethod.brand.toLocaleLowerCase() == 'visa') {
                return false;
            }
        }

        if(this.model.total <= 0 ) return false;
        return true;
    }


    private _getPaymentMethods(userId: number, showSpinner = true) {

        // No hacer la llamada si no esta logueado
        if (!this.user) return;

        if (showSpinner) this.sharedService.setLoading(true);

        return this.apiAccountService.getAllCards(userId).then(
            (cards: CustomerCardModel[]) => {

                this.currentMethod = cards.find(x => x.isCurrent);
                if (this.currentMethod) {
                    this.selectedMethod = this.currentMethod.token;
                }

                this.methods = cards; // update the source

                if (showSpinner) this.sharedService.setLoading(false);
            },
            (err: any) => {

                if (showSpinner) this.sharedService.setLoading(false);
            }
        );
    }
}
